<template>
  <div class="eat" :class="$store.state.theme">
    <MainBackButton />

    <div
      class="field is-grouped is-pulled-right navigation"
      style="margin-bottom: 4px"
      :key="z"
    >
      <div class="control has-icons-left has-icons-right search" :class="theme">
        <span class="icon is-small is-left">
          <i class="fas fa-search has-text-warning" />
        </span>
        <span
          class="icon is-small is-right"
          style="pointer-events: initial"
          v-show="searchTerm"
          @click="clearSearch"
        >
          <i class="fa fa-times-circle" />
        </span>
        <input
          ref="input"
          class="input is-white"
          type="text"
          v-model="searchVal"
          :placeholder="searchPlaceholder"
          @keyup="search($event.target.value)"
          @focus="search($event.target.value)"
          @blur="clearSearch"
        />
      </div>

      <div class="control">
        <span class="button is-rounded is-white" @click="toggleView">
          <span class="icon has-text-grey">
            <i v-if="listView" class="fa fa-globe-asia fa-lg" />
            <i v-else class="fa fa-list" />
          </span>
        </span>
      </div>

      <div class="control">
        <i class="badge pulse-gold" />
        <span class="button is-rounded is-white" @click="showFiltersPanel">
          <span class="icon">
            <i class="fa fa-filter has-text-grey" />
          </span>
        </span>
      </div>
    </div>

    <!-- <EatLive /> -->
    <EatPromos @focusSearch="focusSearch" />

    <keep-alive>
      <EatList v-if="listView" :forceRegion="forceRegion" />
      <EatMap v-else />
    </keep-alive>

    <!-- <EatFiltersPanel @applyFilters="applyFilters" /> -->
    <EatFiltersPanel />
  </div>
</template>

<script>
import EventBus from "../eventBus";
import MainBackButton from "@/components/MainBackButton.vue";
import EatList from "@/components/EatList.vue";
import EatMap from "@/components/EatMap.vue";
import EatPromos from "@/components/EatPromos.vue";
import EatFiltersPanel from "@/components/EatFiltersPanel.vue";

export default {
  name: "Eat",
  components: {
    MainBackButton,
    EatList,
    EatMap,
    EatPromos, // EatLive
    EatFiltersPanel,
  },
  data() {
    return {
      listView: true,
      //   selected: "shops",
      sortedBy: "alphabet", // default sort
      searching: false,
      z: 10, // ?
      searchPlaceholder: "Search restaurants",
      // search: null
      searchResult: [],
      noResults: false,
      searchVal: null,
      searchTerm: null,
      lastSearch: null, // store last search when searchVal/searchTerm clear
      forceRegion: false, // used by eat list to ignore distance
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
    eateries() {
      var shops = this.$store.state.eateries; //this.$store.getters.getShops;
      shops = shops.filter((b) => !b.data.hidden); // hide hidden shops from list
      return shops;
    },
  },
  mounted() {
    this.cycleSearchPlaceholder();
    // this.checkLangQuery(); // prefix e.tuk or query lang=en
    this.updateForYouEatRecommendations();

    EventBus.$on("SHOP_LIST_SEARCH", (s) => {
      if (!s) this.clearSearch();
    });
  },
  activated() {
    this.forceRegion = false;
    this.checkLangQuery(); // prefix e.tuk or query lang=en
    var query = this.$route.query; // look for s for search
    if (query.s) {
      if (query.s[0] === "*") {
        // trigger a filter/promo
        this.clearSearch();
        EventBus.$emit("SET_EAT_FILTER", query.s);
      } else {
        this.searchVal = query.s;
        this.search(query.s);
      }
    }
    if (query.r) {
      this.forceRegion = true; // force region if passed in query
      if (query.r === "cm") this.chooseCity("Chiang Mai"); // set region
      if (query.r === "bk") this.chooseCity("Bangkok"); // set region
      if (query.r === "sg") this.chooseCity("Singapore"); // set region
      if (query.r === "lb") this.chooseCity("Lisbon");
    }
    // if (query.filter) this.sortBy("filter");

    this.$nextTick(() => this.updateEateries(true)); // gets nearby EAT businesses, replaced getBusinesses
  },
  methods: {
    focusSearch() {
      this.$refs.input.focus();
    },
    updateForYouEatRecommendations() {
      this.$store
        .dispatch("getRecommendationsForYouEat")
        .then((res) => console.log("ForYouEat", res.data))
        .catch((err) => this.apiError(err));
    },
    // setForYouScore(forYou) {
    //   forYou.forEach((k, v) => {
    //     // console.log("forYou check", k, v);
    //     for (var i = 0; i < this.eateries.length; i++) {
    //       if (k === this.eateries[i].id) {
    //         this.eateries[i].for_you = v;
    //         break;
    //       }
    //     }
    //   });
    // },
    chooseCity(city) {
      var coords = null; // could set default coords here
      switch (city) {
        case "Bangkok":
          coords = { lat: 13.7321, lon: 100.5696 };
          break;
        case "Chiang Mai":
          coords = { lat: 18.796143, lon: 98.979263 };
          break;
        case "Bagan":
          coords = { lat: 21.20129, lon: 94.908509 };
          break;
        case "Pakokku":
          coords = { lat: 21.33562, lon: 95.0171976 };
          break;
        case "Singapore":
          coords = { lat: 1.29027, lon: 103.851959 };
          break;
        case "Lisbon":
          coords = { lat: 38.71709, lon: -9.13926 };
          break;
      }
      this.$store.commit("setUserState", coords); // your fakeLocation
      this.$store.commit("setRegion", city);
      //   this.updateDataForSelectedRegion();
    },
    cycleSearchPlaceholder() {
      var strings = [
        "search-restaurants",
        "search-dishes",
        "search-foods",
        // "search-food-examples",
        "search",
      ];
      var i = 0;
      setInterval(() => {
        i += 1;
        if (i >= strings.length) i = 0;
        this.searchPlaceholder = this.$t(`home2.${strings[i]}`);
      }, 1500);
    },
    showFiltersPanel() {
      this.log("eat_filters_panel");
      this.showComponent(".eat-filters-panel-component");
      EventBus.$emit("OPEN_EAT_FILTERS_PANEL");
    },
    clearSearch() {
      this.searchVal = null;
      this.searchTerm = null;
      this.noResults = false;
      setTimeout(() => (this.searchResult = []), 300);
    },
    toggleView() {
      this.z += 1;
      this.listView = !this.listView;
      EventBus.$emit("TOGGLE_SHOP_MAP");
    },
    sortBy(type) {
      this.sortedBy = type;
      EventBus.$emit("SHOP_LIST_SORT", type);
    },
    search(text) {
      this.searchTerm = text;
      EventBus.$emit("SHOP_LIST_SEARCH", text.toLowerCase());
    },
  },
};
</script>

<style scoped>
/* Should have a wrapper with max-width so main body can be dark too */
.eat {
  overflow: hidden;
  height: 100vh;
  width: 100vw;
  max-width: 700px;
  margin: auto;
  outline: 1px solid #ddd;
}
.navigation {
  padding-right: 10px;
  padding-top: 10px;
  width: calc(100vw - 56px);
  max-width: calc(700px - 56px);
  margin: auto;
}
.dark {
  /* background-color: #123; */
  background-color: rgb(59, 59, 59);
  color: white;
}
.dark .fa-search {
  color: #2693da !important;
}
/* .dark .card {
  background-color: rgb(0, 56, 113);
  color: white;
} */
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
.single-line::-webkit-scrollbar {
  display: none;
}
.icon:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.select {
  padding-right: 0;
}
.button {
  padding: 13px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);
}
.input {
  width: calc(100vw - 56px - 102px);
  max-width: calc(700px - 56px - 102px);
  padding: 0 12px;
}
.input {
  /* border-radius: 20px; */
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);
  background-color: rgba(255, 255, 255, 0.9);
}
input:focus {
  /* border-color: #209cee; */
  border-color: #ccc;
}
.dark .input {
  background-color: #444;
  border: 1px solid black;
  color: white;
}
.dark input::-webkit-input-placeholder {
  color: #888 !important;
}
.field.is-grouped > .control {
  margin-right: 8px;
}
.badge {
  z-index: 1;
  position: absolute;
  margin-top: -2px;
  margin-left: 25px;
  background-color: #ff3860 !important;
  border-radius: 50%;
  padding: 6px;
}
.pulse-gold {
  animation: shadow-pulse-gold 1s infinite;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 5px rgba(247, 211, 8, 0.5);
  }
}
@keyframes shadow-pulse-blue {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 255, 255, 0.95);
  }
  100% {
    box-shadow: 0 0 0 5px rgba(0, 255, 255, 0.5);
  }
}
</style>
